/**
 * Umoznuje definovat bloky kterete se pri prekroceni view portu prilepi
 * bud k horni nebo doplni hrane
 *
 * <div
 *      data-class-switch="aboveView|underView" -- typ spousteci udalosti
 *      data-class-switch-offset="56"           -- posunutí offsetu pro udalosti souvisejici s pohybem
 *      data-class-switch-class="some-class"    -- trida ktera se vlozi, pripadne vyjme, hleda se i ve vsech potomcich
 *      >
 *     <div data-class-switch-class="some-other-class">...</div>
*  </div>
 */
import * as DOMHelpers from './DOMHelpers';

const INIT_ATT = 'data-class-switch';
const CLASS_ATT = 'data-class-switch-class';
const OFFSET_ATT = 'data-class-switch-offset';

function processUnderView(box)
{
    removeClasses(box);
    box.style.height = box.clientHeight+'px';
    box.style.minHeight = box.clientHeight+'px';

    if(isUnderViewPort(box)) {
        addClasses(box);
    }
}

function processAboveView(box)
{
    removeClasses(box);
    box.style.height = box.clientHeight+'px';
    box.style.minHeight = box.clientHeight+'px';

    if(isAboveViewPort(box)) {
        addClasses(box);
    }
}

function isAboveViewPort(box)
{
    let offset = box.getAttribute(OFFSET_ATT) || 0.1;
    return box.getBoundingClientRect().top < offset;
}

function isUnderViewPort(box)
{
    let offset = window.innerHeight - (box.getAttribute(OFFSET_ATT) || 0);
    return box.getBoundingClientRect().bottom > offset;
}

function addClasses(box)
{
    let boxClass = box.getAttribute(CLASS_ATT);

    if(boxClass !== null) {
        DOMHelpers.addClass(box, boxClass);
    }

    box.querySelectorAll('['+CLASS_ATT+']').forEach(function(item) {
        DOMHelpers.addClass(item, item.getAttribute(CLASS_ATT));
    });
}

function removeClasses(box)
{
    let boxClass = box.getAttribute(CLASS_ATT);

    if(boxClass !== null) {
        DOMHelpers.removeClass(box, boxClass);
    }

    box.querySelectorAll('['+CLASS_ATT+']').forEach(function(item) {
        DOMHelpers.removeClass(item, item.getAttribute(CLASS_ATT));
    });
}

function process()
{
    document.querySelectorAll('['+INIT_ATT+']').forEach(function(box) {
        if(box.getAttribute(INIT_ATT) === 'underView') {
            processUnderView(box);
        } else {
            processAboveView(box);
        }
    });
}

export function run()
{
    process();

    window.addEventListener('scroll', function() {
        process();
    });
}
